<template>
  <div class="product">
    <!-- <banner img="../assets/img/bgtop.jpg" title="产品中心" /> -->
    <!-- <div class="product-content" v-loading="loading"> -->
<div class="product-content">
      <!-- 农网末端低电压治理装置 -->
      <div class="product-img6">
        <div class="content">
          农网末端低电压治理装置专用于农村配网低电压台区治理。<br>保障电网安全运行的同时，大大提高农村用电的可靠性，解决农村部分分散用户用电电能质量差的问题。
        </div>
        <a class="product-more" @click="toProduct6">点击了解更多</a>
      </div>

      <!-- 充电桩平台 -->
      <div class="product-img1">
        <div class="content">
          新能源光储充集成系统是面向充电运营商、充电站管理者的一套充电分析管理集成软件。<br>
          采用物联网、云计算等前沿技术，将光伏发电、电能储存、车辆充电集成信息汇集到云端系统。<br>
          为充电设施的运营运维提供数据预测、分析服务，提高设备盈利能力、降低运维成本。
        </div>
        <a class="product-more" @click="toProduct1">点击了解更多</a>
      </div>
      
      <!-- 综合能源服务平台 -->
      <div class="product-img2" align="center" style="padding-bottom: 30px;">
        <div>
          <img class="product-img product-title" src="../assets/img/product_img2_title.jpg">
        </div>
        <div class="content" align="center">
          中恒综合能源服务平台是以物联网为载体，以大数据、人工智能等技术为基础，提供综合能源供应、销售、消费服务的综合服务云平台。<br>
          平台以能源用户为中心，提供信息采集、能效分析、节能服务、需求响应、能源托管、能源交易、能源生产、<br>
          工程建设等服务，为综合能源服务商的客户服务、业务创新、商业模式创新等提供支持。<br>
          综合能源服务平台支撑企业综合能源、园区综合能源、智慧城市综合能源运营。
        </div>
        <a class="product-more" @click="toProduct2">点击了解更多</a>
        <div>
          <img class="product-img" style="height:500px; width:800px;" src="../assets/img/product_img2.png">
        </div>
        <div class="content">
          综合能源服务商的运行监视、调度指挥、客户服务、运营管理、能力提升平台<br>
          能源用户的信息互动、资产运维、能效优化、交易服务、智慧用能平台
        </div>
        <img src="../assets/img/product_jiantou.png" class="product-jiantou">
      </div>

      <!-- 快频响应控制装置 -->
      <!-- <div class="product-img3">
        <div class="content-wrap">
          <div class="content">
            光伏/风电快速频率响应控制系统是中恒善能自主研发的应用于新能源行业的新产品。主要包括了行业成熟大型水电厂电调柜的核心技术、多路电气硬件测频技术、微电网及新能源能量管理系统的技术，以及新能源快速调频算法。
          </div>
          <a class="product-more" @click="toProduct3">点击了解更多</a>
        </div>
      </div> -->

      <!-- 发电厂辅机控制系统 -->
      <!-- <div class="product-img4">
        <div class="content-wrap">
          <div class="content" style="-webkit-line-clamp: 切换5;">
            中恒善能的辅机控制系统软、硬件均以平台方式研发而成，开放式系统设计，软硬件均可升级。实现了双主机冗余、历史数据库冗余配置。数据处理能力强，响应速度快、稳定。系统维护能力强，减轻用户负担。
          </div>
          <a class="product-more" @click="toProduct4">点击了解更多</a>
        </div>
      </div> -->

      <!-- 无源传感器 -->
      <!-- <div class="product-img5">
        <div class="content-wrap">
          <div class="content">
            针对未来确保电气设备可靠性和检修决策，中恒善能通过在无线传感器技术的多年技术积淀，针对开关设备、电缆等一次设备加装测温、局放等状态监测传感器，应用到新能源开关站等带电设备的温度在线监测。
          </div>
          <a class="product-more" @click="toProduct5">点击了解更多</a>
        </div>
      </div> -->

      <!-- 更多产品 -->
      <div style="width:100%; height: 300px; text-align:center;">
        <swiper class="swiImg" :options="swiperOption" ref="mySwiper" v-if="commodity.length!=0">
          <swiper-slide v-for="(item,index) in commodity" data-index="index" :key="index" class="item">
            <img class="swiImg" :src="item.url" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>

    </div>
  </div>
</template>

<script>
let vm = null;
import { swiper, swiperSlide } from "vue-awesome-swiper";
// import Banner from "../components/Banner";
export default {
  data() {
    return {
      loading: true,
      videoSrc: "http://www.shkjem.com/video/kj.mp4",
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0, 4.0, 8.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "http://www.shkjem.com/video/kj.mp4" //url地址
          }
        ],
        //poster: "../assets/img/home_top.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true //全屏按钮
        }
      },
      commodity: [
        {
          url: require("../assets/img/banner2.jpg")
        },
        {
          url: require("../assets/img/banner3.jpg")
        }
      ],
      imgIndex: 1,
      swiperOption: {
        notNextTick: true,
        loop: true,
        initialSlide: 0,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        speed: 800,
        direction: 'horizontal',
        // grabCursor: true,
        grabCursor: false,
        // 滑动后回调函数
        on: {
          slideChangeTransitionStart: function() {
          this.imgIndex = this.realIndex + 1;  //获取轮播图片下标索引；这里有一个坑，之前网上找到的是用activeIndex，但后来网上说的是这个realIndex，原来activeIndex是swiper2.0的；而realIndex是swiper3.0的，（使用realIndex才实现了下标索引）
          // alert(123);
          },
          click : function() {
            const realIndex = this.realIndex;
            vm.toPage(realIndex);
          }
        },
        //分页器设置
        pagination: {
          el: ".swiper-pagination",
          clickable: true,    
          type: "bullets"
        }
      }
    };
  },
  components: {
   // Banner
    swiper,
    swiperSlide,
  },
  created() {
    vm = this,
    this.$http
      .get(
        "DataDictionary/GetDataDictionaryAll?key=%E4%BA%A7%E5%93%81%E8%A7%86%E9%A2%91%E9%93%BE%E6%8E%A5"
      )
      .then(response => {
        this.videoSrc = response.data[0].Content;
        window.console.log(this.videoSrc);
        this.loading = false;
      })
      .catch(function(error) {
        window.console.log(error);
      });
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    // 点击轮播图跳转
    toPage(index) {
      if(index === 0){
        // 索引0的路由
        //this.$router.push({name: 'productdetails', params: { id: 1}})
        this.$router.push('/product5');
      }else if(index === 1) {
        //this.$router.push({name: 'productdetails', params: { id: 2}})
        this.$router.push('/product4');
      }
    },

    //展示跳转
    toProduct1() {
      //this.$router.push({name: 'casedetails', params: { id: 29}})
      this.$router.push('/product1')
    },
    toProduct2() {
      //this.$router.push({name: 'casedetails', params: { id: 29}})
      this.$router.push('/product2')
    },
    toProduct3() {
      //this.$router.push({name: 'casedetails', params: { id: 29}})
      this.$router.push('/product3')
    },
    toProduct4() {
      this.$router.push({name: 'casedetails', params: { id: 29}})
    },
    toProduct5() {
      this.$router.push({name: 'casedetails', params: { id: 29}})
    },
    toProduct6() {
      this.$router.push('/product6')
    }
  }
};
</script>

<style lang="scss" scoped>
.product {
  width: 100%;
  height: 100%;
  // background-color: #14679f;
}

.product-content {
  width: 1240px;
  margin: 0 auto;
  background-color: #fff;

  .content {
    width: 915px;
    margin: 0 auto 50px;
    padding-top: 200px;
    text-align: center;
    color: #808080;
    font-size: 14px;
    line-height: 22px;
  }
}

.product-img6 {
  width: 100%;
  height: 863px;
  background: url(../assets/img/product_img6.jpg) center;
  text-align: center;
}
.product-img1 {
  width: 100%;
  height: 863px;
  background: url(../assets/img/product_img1.jpg) center;
  text-align: center;
}

.product-more {
  display: inline-block;
  cursor: pointer;
  width: 166px;
  height: 44px;
  line-height: 44px;
  border-radius: 22px;
  color: #fff;
  text-align: center;
  position: relative;
  top: 0;
  transition: 0.5s;
  background: linear-gradient(to right, #2895f8, #30a9f9);
  background-color: #2895f8;
}


.product-img2 {
  width: 100%;
  text-align: center;

  .product-img {
    margin-bottom: 20px;
  }
  .product-title {
    // margin-top: 100px;
    padding-bottom: 10px;
  }
  .product-more {
    margin-top: 40px;
    margin-bottom: 50px;
  }
  .content {
    width: 915px;
    margin: 0 auto;
    padding-top: 0px;
    text-align: center;
    color: #808080;
    font-size: 14px;
    line-height: 22px;
  }
  .product-jiantou {
    margin-top: 30px;
  }
}

.product-img3 {
  position: relative;
  width: 100%;
  height: 730px;
  background: url(../assets/img/product_img3.jpg) center;

  .content-wrap {
    position: absolute;
    left: 145px;
    top: 275px;
  }

  .content {
    color: #666;
    text-align: left;
    font-size: 14px;
    line-height: 22px;
    padding-top: 0px;
    max-width: 450px;
    margin-bottom: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
}

.product-img4 {
  position: relative;
  height: 690px;
  background: url(../assets/img/product_img4.jpg) center;

  .content-wrap {
    position: absolute;
    left: 645px;
    top: 205px;
  }

  .content {
    color: #666;
    text-align: left;
    font-size: 14px;
    line-height: 22px;
    padding-top: 80px;
    max-width: 450px;
    margin-bottom: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  }
}

.product-img5 {
  position: relative;
  height: 808px;
  background: url(../assets/img/product_img5.jpg) center;

  .content-wrap {
    position: absolute;
    left: 145px;
    top: 275px;
  }

  .content {
    color: #666;
    text-align: left;
    font-size: 14px;
    line-height: 22px;
    padding-top: 70px;
    max-width: 450px;
    margin-bottom: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
}

// 轮播图
.commodity{
  background: #f5f5f5;
  width: 100px;
 
  .container{
    position: relative;

    .swiText {
      position: absolute;
      height: 0.5rem;
      width: 0.5rem;
      bottom: 0.2rem;
      right: 0.3rem;
      font-size: 0.33rem;
      color: #fff;
      z-index: 10;
    }
 
    .swiImgs {
      width: 100%;
      .item{
        height: 7.5rem;
        .swiImg {
          width: 100%;
        }
      }
    }
  }
}


.slide-one {
  background: url(../assets/img/banner1.jpg) no-repeat center;
  background-size: cover;
}
.slide-two {
  background: url(../assets/img/banner3.jpg) no-repeat center;
  background-size: cover;
}



</style>